import React from 'react';

interface Props {
  size?: number;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}

// Straight right arrow (tabler:arrow-right) — the trailing glyph on the "PROCEED TO REVIEW" CTA
// (ticket 7127, screen 18). Defaults to white for use on the gradient button.
export const ArrowRightSvg: React.FC<Props> = ({ size = 22, color = '#FFFFFF', style, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <path
      d="M4.58333 11H17.4167M17.4167 11L11.9167 5.5M17.4167 11L11.9167 16.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
